const ReferralFaqContent = [
  {
    title: 'Do you offer any discounts?',
    info: [
      {
        pretext:
          'Drive with Autzu and earn up to $100 in credits every week! '
      },
      {
        text: {
          plaintext:
            "Book 50 hours or more, and you'll receive a $50 credit"
        }
      },
      {
        text: {
          plaintext:
            "Book 80 hours or more, and you'll receive a $100 credit"
        }
      }
    ]
  },
  {
    title: 'Do you offer referral bonuses?',
    info: [
      {
        pretext:
          'You and a friend can both earn $150 each. Share your referral link found in the Promotions section of the Autzu app.'
      },
      {
        text: {
          plaintext:
            "Once your friend completes 20 hours of driving, you'll both receive $50."
        }
      },
      {
        text: {
          plaintext:
            'When your friend completes 100 hours of driving, you’ll both receive another $100'
        }
      }
    ]
  }
];

export default ReferralFaqContent;



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/ReferralFaqContent.js